import { type JSX, render } from 'preact';
import { Route, Switch } from 'wouter-preact';

import { PageTitle } from './components/PageTitle.tsx';
import { BlogPage } from './pages/BlogPage.tsx';
import { BlogPostPage } from './pages/BlogPostPage.tsx';
import { HomePage } from './pages/HomePage.tsx';
import { NotFoundPage } from './pages/NotFoundPage.tsx';

export const AppRouter = (): JSX.Element => {
  return (
    <PageTitle title="Seahax">
      <Switch>
        <Route path="/">
          <HomePage />
        </Route>
        <Route path="/blog">
          <BlogPage />
        </Route>
        <Route path="/blog/:postId">
          {({ postId }) => {
            if (/[^a-z0-9-]/iu.test(postId)) return <NotFoundPage />;
            return <BlogPostPage postId={postId} />;
          }}
        </Route>
        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
    </PageTitle>
  );
};

render(<AppRouter />, document.getElementById('app')!);
